import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode } from "vue"

import InfoMessage from '@/components/InfoMessage.vue';
import { useI18n } from 'vue-i18n';
import { computed } from 'vue';
import { ENABLE_FAKE_CARDANO_NETWORK } from '@/helpers/fakeCardanoNetwork';
import { usePortfoliosMilkomedaWSCBridge } from '@/store/modules/portfolios/usePortfoliosMilkomedaWSCBridge';


export default /*#__PURE__*/_defineComponent({
  __name: 'NotEnoughCurrencyForFeeNotice',
  setup(__props) {

const { t } = useI18n();
const { milkomedaWSCBridgeState } = usePortfoliosMilkomedaWSCBridge();

const isShowNotEnoughCurrencyForFee = computed(
  () =>
    ENABLE_FAKE_CARDANO_NETWORK &&
    milkomedaWSCBridgeState.needBridge &&
    !milkomedaWSCBridgeState.isValidCardanoBalance,
);

return (_ctx: any,_cache: any) => {
  return (_unref(isShowNotEnoughCurrencyForFee))
    ? (_openBlock(), _createBlock(InfoMessage, {
        key: 0,
        type: "error",
        "as-panel": "",
        class: "mb-s3"
      }, {
        default: _withCtx(() => [
          _createTextVNode(_toDisplayString(_unref(t)('wrappedContract.notEnoughCurrencyForFee', {
        amount: _unref(milkomedaWSCBridgeState).minADABalance,
        symbol: 'ADA',
      })), 1)
        ]),
        _: 1
      }))
    : _createCommentVNode("", true)
}
}

})